import styled from "styled-components";
import Text from "./Text";

const InputContainer = styled.div`
  border: 1px solid black;
  padding: 6px 12px;
  border-radius: 6px;
  background-color: white;
`;


interface TextInput {
    placeholder: string,
    value: any,
    onChangeValue: (value) => void,
    id: any,
    type: "text" | "password",
    style?: {}
}

const TextInput = ({ style, placeholder, value, onChangeValue, id, type }: TextInput) => {
    return (
        <InputContainer style={style}>

            <Text text={placeholder} size="0.65rem" weight="400" style={{ lineHeight: 1 }} />
            <input
                id={id}
                type={type == "text" ? "text" : "password"}
                value={value}
                onChange={(e) => onChangeValue(e.target.value)}
                style={{ border: 0, width: "100%", outline: "none", fontFamily: "inherit", padding: "5px 0 3px 0", fontSize: "0.85rem" }}
            />
        </InputContainer>
    )
}

export default TextInput;